<template>
  <v-container id="my-groups" fluid tag="section">
    <v-overlay :value="isOverlayVisible">
      <v-progress-circular :size="70"
                           :width="7"
                           color="green"
                           indeterminate
                           class="spinner" />
    </v-overlay>
    <div class="titleWrapper">
      <base-v-component heading="Services" sub-heading="Service List" />
    </div>
    <template>
      <v-toolbar flat color="transparent" class="actionbar">
        <v-btn color="primary" dark class="mb-2" @click="addMessagingService">
          <v-icon small class="mr-2"> mdi-plus </v-icon>
          Add Messaging Service
        </v-btn>
        <messaging-service-add-edit-dialog :selected-messaging-service="selectedMessagingServiceToEdit"
                                           :is-edit-mode="isMessagingServiceEditMode"
                                           :is-visible="isMessagingServiceDialogVisible"
                                           :selected-clinic="selectedClinic"
                                           @on-submit="onMessagingServiceAddEditDialogSubmit"
                                           @show-loader="showLoader"
                                           @hide-loader="hideLoader"
                                           @on-close="hideMessagingServiceAddEditDialog"
                                           @on-success="onMessagingServiceAddEditDialogSubmitSuccess"
                                           @on-error="onMessagingServiceAddEditDialogSubmitError" />
      </v-toolbar>
    </template>

    <v-data-table :headers="servicesHeaders"
                  :items="services"
                  sort-by="senderName"
                  class="elevation-1">
      <template v-slot:[`item.deploy`]="{ item }">
        <v-simple-checkbox :value="item.isDeployed"
                           @click="editMessagingService(item)" />
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>

      <template v-slot:no-data>
        <p class="mb-4 mt-4">No services to display</p>
        <v-btn color="primary" outlined class="mb-4" @click="initialize">
          Refresh
        </v-btn>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <div class="py-3" />
  </v-container>
</template>

<script>
  /* eslint-disable */
  import Api from "../../../modules/shared-module/api";

  export default {
    name: "ManageMessagingServices",
    components: {
      MessagingServiceAddEditDialog: () => import(
        "../messaging-service-add-edit-dialog/messaging-service-add-edit-dialog.vue"
      ),
    },
    props: {
      selectedClinic: {
        type: Object,
        default: () => { }
      }
    },
    data: () => ({
      servicesHeaders: [
        { text: "Service Name", value: "MSName" },
        { text: "Service Number", value: "MSPhoneNumber" },
        { text: "Deploy", value: "deploy", sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      services: [{}],
      snackbar: false,
      notification: "Unknown",
      phoneNumbers: [],
      isOverlayVisible: false,
      selectedPhoneNumberToEdit: null,
      isPhoneEditMode: false,
      isPhoneDialogVisible: false,
      isAddTwilioProvisionNumberDialogVisible: false,
      isMessagingServiceEditMode: false,
      isMessagingServiceDialogVisible: false,
      selectedMessagingServiceToEdit: {}
    }),

    watch: {
      selectedClinic: {
        immediate: true,
        deep: true,
        handler(newValue) {
          if (newValue) {
            this.initialize();
          }
        }
      },
    },

    methods: {
      async initialize() {
        try {
          this.isOverlayVisible = true;
          await this.fetchMessagingServices();
          this.isOverlayVisible = false;
        } catch (error) {
          this.isOverlayVisible = false;
        }
      },

      async fetchMessagingServices() {
        try {
          const servicesResponse = await Api.messagingService.private.fetchServices(this.selectedClinic.Practice_ID);
          this.services = servicesResponse.data;
        } catch (error) {
          console.log("error", error);
        }
      },

      editMessagingService(item) {
        if (!item.isDeployed) {
          this.isMessagingServiceEditMode = true;
          this.selectedMessagingServiceToEdit = item;
          this.isMessagingServiceDialogVisible = true;
        } else {
          this.notification = "Service already deployed!";
          this.snackbar = true;
        }
      },

      addMessagingService() {
        this.isMessagingServiceEditMode = false;
        this.isMessagingServiceDialogVisible = true;
      },

      onMessagingServiceAddEditDialogSubmit() {
        this.isOverlayVisible = true;
      },

      async onMessagingServiceAddEditDialogSubmitSuccess() {
        this.isMessagingServiceDialogVisible = false;
        await this.fetchMessagingServices();
        this.isOverlayVisible = false;
      },

      onMessagingServiceAddEditDialogSubmitError() {
        this.isOverlayVisible = false;
      },

      hideMessagingServiceAddEditDialog() {
        this.isMessagingServiceDialogVisible = false;
      },

      onSpinnerHide() {
        this.isOverlayVisible = false;
      },

      showLoader() {
        this.isOverlayVisible = true;
      },

      hideLoader() {
        this.isOverlayVisible = false;
      },
      async deleteItem(item) {
        // eslint-disable-next-line no-alert
        if (window.confirm(`Are you sure you want to delete '${item.MSName}' Messaging Service?`)) {
          if (item.MSSID) {
            try {
              await Api.messagingService.private.removeMessagingService(item.MSSID);
              this.notification = `Messaging Service${item.MSName} has been deleted.`;
              this.snackbar = true;
              await this.fetchMessagingServices();
            } catch (error) {
              this.notification = `Unable to delete the Messaging Service ${item.MSName}`;
              this.snackbar = true;
            }
          } else {
            this.notification = `Messaging Service MSSID not available`;
            this.snackbar = true;
          }
        }
      }
    },
  };
</script>


<style scoped>
  .v-overlay.v-overlay--active.theme--dark {
    z-index: 300 !important;
  }

  .spinner {
    margin-left: 17rem;
  }

  @media only screen and (max-width: 968px) {
    .spinner {
      margin-left: 0;
    }
  }

  .elevation-1 {
    margin-top: 3rem !important;
  }

  .titleWrapper {
    margin-top: 4rem;
    margin-bottom: -1rem;
  }

  .actionbar {
    margin-bottom: -25px;
    display: flex !important;
    justify-content: flex-end !important;
  }

  .senderActions {
    display: flex;
    width: 100px;
    justify-content: space-between;
  }
</style>
